import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonToolbar,
} from '@ionic/react'

import { useInfiniteData } from '../../../../hooks/use-infinite-data'
import { useClientStations } from '../../../../check-in/paired/queries'
import { CheckInListItem } from '../../../../check-in/paired/components/check-in-list-item'

function CheckInHome() {
  const stations = useClientStations()
  const flatStations = stations.data?.pages.flatMap((d) => d.data)

  const [ionInfiniteScrollRef, loadMore] = useInfiniteData(
    stations.fetchNextPage
  )

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="secondary" />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding space-y-3">
        <div className="flex justify-center">
          <IonButton
            color="yellow"
            routerLink="/check-in/paired/admin/phone-check-in"
          >
            Manual Check-In
          </IonButton>
        </div>

        {flatStations ? (
          <div className="space-y-5">
            {flatStations.map((checkIn) => (
              <CheckInListItem
                key={checkIn.objectId}
                href={
                  checkIn.client
                    ? `/check-in/paired/admin/redeem-loyalty?clientId=${checkIn.client.objectId}`
                    : undefined
                }
                stationClient={checkIn}
              />
            ))}
            <IonInfiniteScroll
              ref={ionInfiniteScrollRef}
              onIonInfinite={loadMore}
              threshold="100px"
              disabled={!stations.hasNextPage}
            >
              <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="loading..."
              />
            </IonInfiniteScroll>
          </div>
        ) : (
          <IonLoading message="Loading Past Check-Ins" isOpen />
        )}
      </IonContent>
    </IonPage>
  )
}

export { CheckInHome }
